import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import App from "./App";

// Get the root element
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

// Render the full app
createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
